import { render, staticRenderFns } from "./SelectRoleModal.vue?vue&type=template&id=061a91eb&scoped=true&"
import script from "./SelectRoleModal.vue?vue&type=script&lang=js&"
export * from "./SelectRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoleModal.vue?vue&type=style&index=0&id=061a91eb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a91eb",
  null
  
)

export default component.exports